import { DEFAULT_LANGUAGE, Language } from "../../language";
import { DEFAULT_THEME, ThemeMode } from "../../theme";

export interface UserPreferences {
	userId?: string;
	messagingEmails: boolean;
	orderProposalEmails: boolean;
	fundingEmails: boolean;
	orderReportEmails: boolean;
	theme?: ThemeMode;
	language?: Language;
	seenTourIds?: string[];
	toursOptedOut?: boolean;
}

/** Default values applied when a setting key is absent — mirrors the backend defaults. */
export const USER_PREFERENCES_DEFAULTS: UserPreferences = {
	messagingEmails: true,
	orderProposalEmails: true,
	fundingEmails: true,
	orderReportEmails: false,
	theme: DEFAULT_THEME,
	language: DEFAULT_LANGUAGE
};
